import type { AdminSetAccountAttributesInput } from '../api'
import { api } from '../api'

const setAccountAttributes = async (data: AdminSetAccountAttributesInput) => {
  return await api.v1.adminSetAccountAttributes(data)
}

export { setAccountAttributes }
